import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/UseAuth"; 
import { ReactNode, useEffect } from "react";

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    // Check if auto-login for dev is enabled
    if (process.env.REACT_APP_DEBUG_AUTO_LOGIN === "true") {
      const dummyEmail = process.env.REACT_APP_DUMMY_ACCOUNT_EMAIL;
      const dummyPassword = process.env.REACT_APP_DUMMY_ACCOUNT_PASSWORD;
      const logindata = {
        email: dummyEmail,
        password: dummyPassword,
      };
    login(logindata, false);
    }
  }, [login]);

  if (!user) {
    // redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};